"use client";

import { c as _c } from "react/compiler-runtime";
import { graphql, useQuery } from "@opensea/graphql";
import { Pill, SkeletonLine } from "@opensea/ui-kit";
import { useCollectionSlugsQueryParam } from "../../hooks/query-param/use-collection-slugs-query-param";
const query = graphql(`
  query CollectionSearchPillsQuery($slugs: [String!]!) {
    collectionsBySlugs(slugs: $slugs) {
      ... on CollectionIdentifier {
        name
        slug
      }
    }
  }
`);
const OPERATION_CONTEXT = {
  suspense: false
};
export function CollectionSearchPills() {
  const $ = _c(12);
  const {
    collectionSlugs,
    onSelectCollection
  } = useCollectionSlugsQueryParam();
  let t0;
  if ($[0] !== collectionSlugs) {
    t0 = {
      slugs: collectionSlugs
    };
    $[0] = collectionSlugs;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !collectionSlugs.length;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      query,
      variables: t0,
      pause: t1,
      context: OPERATION_CONTEXT
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const [t3] = useQuery(t2);
  const {
    data
  } = t3;
  let t4;
  if ($[5] !== collectionSlugs || $[6] !== data?.collectionsBySlugs || $[7] !== onSelectCollection) {
    let t5;
    if ($[9] !== data?.collectionsBySlugs || $[10] !== onSelectCollection) {
      t5 = slug => <Pill key={slug} onClick={() => onSelectCollection(slug)}>{data?.collectionsBySlugs.find(c => c.slug === slug)?.name ?? <SkeletonLine className="h-4 w-16" />}</Pill>;
      $[9] = data?.collectionsBySlugs;
      $[10] = onSelectCollection;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    t4 = collectionSlugs.map(t5);
    $[5] = collectionSlugs;
    $[6] = data?.collectionsBySlugs;
    $[7] = onSelectCollection;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}